var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 307 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.4 14.4c6.2 2.7 12.1 6 17.6 9.9a92.4 92.4 0 0190-9.9A94.4 94.4 0 01293.7 64 92.7 92.7 0 01208 193a92.6 92.6 0 01-54-17 92.4 92.4 0 01-53.7 17 92.6 92.6 0 01-86-56.6 92.7 92.7 0 010-72.4A94.4 94.4 0 0164 14.4a92.4 92.4 0 0172.5 0zm-36 22.5A62.6 62.6 0 0056 55.3a64.2 64.2 0 000 89.2 62.3 62.3 0 0076 9.6 92.7 92.7 0 01.4-108.3c-9.6-5.9-20.7-9-32-9zm107.5 0h.1a62.6 62.6 0 00-32.4 8.9A92.5 92.5 0 01176 154a62.3 62.3 0 0056.3 3.7 63.3 63.3 0 0019.8-102.5 61.2 61.2 0 00-44.2-18.4zM154.2 68l-.4.7a64.2 64.2 0 00.3 63 63.2 63.2 0 000-63.7z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressW);
export default __webpack_public_path__ + "assets/media/progress-w.a17d33db.svg";
export { ForwardRef as ReactComponent };